import { Box } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

const Invoicepdf = () => {
    const [response, setresponse] = useState("")
    console.log(response);
    useEffect(() => {
     axios.get("/invoicePdf").then((response)=>{
        setresponse(response.link)
     })
    }, [])
  return (
    <Wrapper>
    <Box sx={{ height: "auto", marginTop: "-20px" }}>
   
      <div className="embed-container" style={{ height:'90vh'}}>
        <embed
          src="/assets/tax_invoice.pdf#toolbar=0"
          type="application/pdf"
        />
      </div>
    </Box>
  </Wrapper>
  )
}





const Wrapper = styled.div`
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0
    overflow: hidden;
  }
  .embed-container iframe,
  .embed-container object,
  .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default Invoicepdf